export default class UserSkill {

    public color: number
    public label: string
    public value: any

    constructor(data: any) {
        this.color = data.color
        this.label = data.label
        this.value = data.value
    }

    get id() {
        return this.value
    }

    toJSON() {
        return {
            value:  this.value,
            label:  this.label,
            color:  this.color,
        }
    }
}
